<template>
  <div id="attendance_record" class="daochu">

      <div id="record_table" style="position: relative">
        <div class="header-selector">
          <el-button size="mini" @click="openDrawer">设置表头显示</el-button>
        </div>
        <!-- <div class="header-selector_right">
          <el-button size="mini" @click="ouPutAsExcel">导出表格</el-button>
        </div> -->
        <div class="table-title"><span>{{title}}</span></div>
        <el-table
          v-loading="loading"
          :data="product_list"
          style="font-size: 14px;"
          size="small"
          class="checkInTableRow"
          :height="height"
          ref="record_table"
          @sort-change="sortChange"
          border
          :highlight-current-row="highlight"
          @current-change="selectItem"
          id="ou">
            <el-table-column v-for="(checkedHeader,index) in checkedHeaders"
              align="center"
              :label="checkedHeader"
              :prop="Object.keys(keyToName).find(key => keyToName[key] === checkedHeader)"
              :key="index"
              sortable="custom"
              :formatter="formatDate"
              :min-width="checkedHeader.length > 5 ? '190' : '120'"
            >
              <template slot-scope="scope">
                <img v-if="checkedHeader === '商品封面图'" :src="$config.product_image_url + 'cover_image/' + scope.row.coverImage" style="width: 50px; height: 50px;">
                <div v-else-if="checkedHeader === '照片'">
                  <img v-for="(image,index) in scope.row.mediaUrls" :key="index" :src="'https://www.suonida.com:8899/refund/' + image" style="width: 50px; height: 50px;">
                </div>
                <div v-else-if="checkedHeader === '商品标签'">
                  <el-tag
                    style="margin-right: 5px;margin-bottom: 5px"
                    v-for="(tag) in scope.row.tags"
                    :key="tag"
                    color="#000"
                    effect="dark">
                    {{tag}}
                  </el-tag>
                </div>
                <div v-else-if="type === 'products' && checkedHeader === '是否可用'">
                  <el-switch
                    v-model="scope.row.status"
                    active-value="on"
                    active-text="上架"
                    inactive-value="off"
                    inactive-text="下架"
                    @change="(status) => productStatusChange(status,scope.row._id)">
                  </el-switch>
                </div>
                <div v-else>
                  {{ formatDate(scope.row,scope.column,scope.row[Object.keys(keyToName).find(key => keyToName[key] === checkedHeader)]) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              fixed="right"
              label="操作"
              min-width="150">
              <template slot-scope="scope">
                <div v-if="!$util.isEmpty(tableHandler)" style="display:flex;justify-content: space-around;">
                  <div v-for="(handler,index) in tableHandler" :key="index">
                    <el-button v-if="handler === 'show'" @click="openEditDialog(scope,'show')" type="text" size="small">查看</el-button>
                    <!-- <el-button v-if="handler === 'copy'" @click="copyData(scope)" type="text" size="small">复制</el-button> -->
                    <el-button v-if="handler === 'edit'" @click="openEditDialog(scope,'edit')" type="text" size="small">编辑</el-button>
                    <el-button v-if="handler === 'del'" @click="delOperate(scope)" type="text" size="small">删除</el-button>
                  </div>
                </div>
                <div v-if="type === 'category'">
                  <el-button @click="deleteCategory(scope)" type="text" size="small">删除</el-button>
                </div>
                <div v-if="type === 'batch'">
                  <el-button @click="openEditDialog(scope,'batch')" type="text" size="small">查看</el-button>
                </div>
                <div v-if="type === 'orders'">
<!--                  <el-button @click="openOrdersOperate(scope,'show')" type="text" size="small">查看</el-button>-->
                  <el-button @click="openOrdersOperate(scope,'wayBill')" type="text" size="small">录入运单号</el-button>
<!--                  <el-button @click="openOrdersOperate(scope,'refund')" type="text" size="small">退款操作</el-button>-->
                </div>
                <div v-if="type === 'nfc'">
                  <el-button @click="openEditDialog(scope,'nfc')" type="text" size="small">上传文件</el-button>
                  <el-popover
                    placement="bottom"
                    title="NFC链接"
                    width="300"
                    trigger="click"
                    :content="'https://www.suonida.com:8899/#/show?type=' + scope.row.type + '&token=' + scope.row._id + '&id=1'">
                    <el-button type="text" size="small" slot="reference">显示NFC链接</el-button>
                  </el-popover>
<!--                  <el-button @click="openEditDialog(scope,'nfcShow')" type="text" size="small"></el-button>-->
                </div>
                <div v-if="type === 'refund'">
                  <el-button v-if="scope.row.processStatus === 'AGREE'" @click="refundWayBill" type="text" size="small">录入运单号</el-button>
                  <el-button v-if="scope.row.processStatus === 'PENDING' || scope.row.processStatus === 'SHIPPED'" @click="openEditDialog(scope,'refund')" type="text" size="small">退款审核</el-button>
                </div>
              </template>
            </el-table-column>
        </el-table>

      </div>

    <u-dialog :dialogVisible="uploadDialogVisible" :groupData="groupData" @change-state="changeDialogState"></u-dialog>

    <el-dialog
      title="录入运单号"
      :visible.sync="waybillNoVisible"
      width="20%"
      :close-on-click-modal="false"
      :before-close="waybillNoClose">
      <div style="margin-top: 20px">
        <el-input placeholder="请输入运单号" v-model="waybillNo"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="waybillNoVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmWayBillNo">确 定</el-button>
        </span>
    </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="delPwdVisible"
      width="20%"
      center
      :close-on-click-modal="false"
      :show-close="false">
      <div>是否删除该商品</div>
      <div><span style="color: red">删除会导致用户订单商品数据丢失，尽可能使用上下架操作</span></div>
      <div style="margin-top: 20px">
        <el-input placeholder="请输入操作密码" type="password" v-model="operatePass"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="delPwdCancel">取 消</el-button>
          <el-button type="primary" @click="confirmDel">确 定</el-button>
        </span>
    </el-dialog>
  </div>

</template>
<script>
import uploadFilesDialog from "../dialog/UploadFilesDialog.vue";

export default {
  props:['product_list','loading', 'title','type','storageName','highlight','height','tableHandler','newCheckHeader','newKeyToName'],
  components: {
    'u-dialog': uploadFilesDialog,
  },
  data() {
    return {
      userType: 4,

      checkedHeaders: ['商品封面图','商品目录', '商品名称','商品单价','库存','是否可用','商品创建日期','商品标签'],
      keyToName: this.$commondata.KEY_TO_NAME,
      uploadDialogVisible: false,
      groupData: {},
      waybillNoVisible: false,
      waybillNo: '',
      orderId: '',
      operatePass: '',
      delPwdVisible: false,
      delInfo: {},
    }
  },
  mounted(){
    let checkedHeaders = localStorage.getItem(this.storageName);
    if(checkedHeaders !== undefined && checkedHeaders !== null){
      this.checkedHeaders = checkedHeaders.split(',');
    }else if(this.newCheckHeader){
      this.checkedHeaders = this.newCheckHeader
    }

    this.keyToName = this.newKeyToName ? this.newKeyToName : this.keyToName;
  },
  watch: {
    // product_list(){
    //   this.$nextTick(() => {
    //     this.$refs.record_table.doLayout();
    //   });
    // },
  },
  methods:{
    ouPutAsExcel() {
      this.$confirm("是否下载当前搜索条件的设备数据",'提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let options = this.$util.formatOptions(this.$commondata.searchObj);
        let result = await this.$equipmentdata.downloadFile(this.type,options);
        let title = "";
        let contentype = {};
        if(this.type === 'machines'){
          contentype = { type: "application/octet-stream" }
          title = "设备台账表-" + new Date().getTime() + ".xlsx";
        }
        else if(this.type === 'operation'){
          title = "借用信息表-" + new Date().getTime() + ".xlsx";
          contentype = {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8'}
        }
        //console.log(result);
        this.$FileSaver.saveAs(
          new Blob([result], contentype),
          title
        );
      })
    },

    formatDate(row,column,cellValue,){
      let title = column.label;
      if(title.includes('日期') && cellValue){
        return this.$util.formatDate(cellValue);
      }
      if(title.includes('时间') && cellValue){
        return this.$util.formatDate(cellValue);
      }
      if(title === '是否可用'){
        if(cellValue === 0) return '可用'
        else if(cellValue === 1) return '已被使用'
        else return cellValue
      }
      if(title === '订单状态'){
        const st = {
          'PENDING': '等待支付',
          'PAID': '已支付',
          'SHIPPED': '正在派送',
          'CANCELLED': '取消订单',
          'FINISH': '完成订单'
        }
        return st[cellValue]
      }
      if(title === '退款状态'){
        const st = {
          'PENDING': '等待审核',
          'AGREE': '审核通过',
          'DISAGREE': '审核不通过',
          'SHIPPED': '退货中',
          'CANCELLED': '取消退款',
          'FINISH': '完成退款',
          'DIRECT': '直接退款'
        }
        return st[cellValue]
      }
      // else if(String(cellValue).length > 9 && title != '新内部编号'){
      //   return String(cellValue).substring(0,7) + " ..."
      // }
      else return cellValue
    },

    formatCell(value) {
      // 这里可以添加自定义格式化逻辑
      console.log(value);
      return '-';  // 空值显示占位符
    },

    openEditDialog(data,type){
      let that = this.$root.$children[0].$children[1].$children[0];
      if(type === 'edit'){ //弹出编辑
        if(this.type === 'category'){

        }else {
          that.$set(that,'machine',data.row);
          that.$set(that,'dialogTitle',"编辑商品");
          that.$set(that,'childrenObject',this);
          that.equipmentDialogVisible = true;
        }
      }else if(type === 'show'){ //弹出展示
        that.$set(that,'machine',data.row);
        that.$set(that,'dialogTitle',"信息展示");
        that.$set(that,'childrenObject',this);
        that.equipmentDialogVisible = true;
      }else if(type === 'add'){ //弹出新增
        that.dialogTitle = "新增设备"
        that.equipmentDialogVisible = true;
      }else if(type === 'batch'){
        //console.log(data.row)
        that.codesDialogVisible = true;
        that.$set(that,'machine',data.row);
        that.$set(that,'childrenObject',this);
      }else if(type === 'nfc'){
        this.uploadDialogVisible = true;
        //console.log(data.row)
        this.groupData = data.row;
        that.$set(that,'childrenObject',this);
      }else if(type === 'nfcShow'){

      }else if(type === 'refund'){
        that.processdialogVisible = true;
        that.$set(that,'machine',data.row);
        that.$set(that,'childrenObject',this);
      }
    },

    async deleteCategory(data){
      console.log(data.row._id);
      const res = await this.$request.delete_category(data.row._id);
      if(res.code === 0){
        this.$message('删除成功')
        this.$emit('data-change');
      }else{
        this.$message(res['errMsg'])
      }
    },

    openOrdersOperate(data,type){
      if(type === 'show'){

      }else if(type === 'wayBill'){
        this.waybillNoVisible = true;
        this.orderId = data.row._id;
        this.waybillNo = data.row.waybillNo;
      }else if(type === 'refund'){

      }
    },

    waybillNoClose(){
      this.waybillNo = "";
      this.orderId = "";
      this.waybillNoVisible = false;
    },

    async confirmWayBillNo(){
      const res = await this.$request.set_waybill(this.orderId,this.waybillNo);
      if(res.code === 0){
        this.$message('录入成功');
        this.$emit('data-change');
      } else if(res.code === -1){
        this.$message(res['errMsg'])
      }
      this.waybillNoVisible = false;
    },

    copyData(data){
      this.$commondata.copyData = data.row;
      this.$message("复制成功");
    },

    //表列点击排序触发
    sortChange(column){
      let o = "";
      if(column.order === "ascending"){
        o = column.prop + " asc"
      }else if(column.order === "descending"){
        o = column.prop + " desc"
      }
      this.$emit('sort-change',{order: o})
    },

    openDrawer(){
      if(this.product_list[0]){
        const that = this.$root.$children[0];
        that.$set(that,'drawerTitle','设备表设置');
        that.$set(that,'headerKey',Object.keys(this.product_list[0]));
        that.$set(that,'checkedHeader',this.checkedHeaders);
        that.$set(that,'keyToName',this.keyToName)
        that.$set(that,'childrenObject',this);
        that.$set(that,'drawerVisible',true);
        that.$set(that,'saveHeaderType',this.storageName);
      }else this.$message('无列表数据')
    },

    refreshData(cb){
      console.log('to refresh')
      this.$emit('data-change',cb);
    },

    selectItem(val){
      if(this.highlight){
        this.$emit('current-change',val);
      }
    },

    changeDialogState(val){
      if(val.refresh) {
        this.$emit('data-change');
      }
      this.groupData = {};
      this.uploadDialogVisible = val.isShow;
    },

    delOperate(data){
      this.delInfo = data.row;
      this.delPwdVisible = true;
      // this.$dialog.confirm({
      //   message: '<div>是否删除该商品</div><div><span style="color: red">删除会导致用户订单商品数据丢失，尽可能使用上下架操作</span></div>' +
      //     '<div style="text-align: center"><input placeholder="请输入操作密码"  :value="operatePass" @input="operatePass= $event.target.value" type="password" /></div>',
      // }).then(async ()=>{
      //   console.log(data.row,this.operatePass);
      //
      //   this.operatePass = "";
      // })
    },

    delPwdCancel(){
      this.delPwdVisible = false;
      this.delInfo = {};
      this.operatePass = "";
    },

    async confirmDel() {
      const urls = []
      if (this.delInfo.coverImage) urls.push(`product/cover_image/${this.delInfo.coverImage}`)
      if (this.delInfo.contentImage) urls.push(`product/content_image/${this.delInfo.contentImage}`)
      if (this.delInfo.images.length > 0) {
        this.delInfo.images.forEach(image => {
          urls.push(`product/images/${image}`)
        })
      }
      const delRes = await this.$request.del_product(this.delInfo._id, this.operatePass);
      if (delRes.code === 0) {
        if (urls.length > 0) await this.$request.drop_files(urls);
        this.$message('删除成功！')
        this.$emit('data-change');
      } else {
        this.$message(delRes['errMsg'])
      }
      this.delPwdCancel();
    },

    async productStatusChange(status,productId){
      const productInfo = {status};
      if(productId) productInfo.id = productId;
      //const result = await this.$request.set_product(productId,{status})
      const result = await this.$request.set_message('products',productInfo);
      if(result.code === 0){
        this.$message("修改成功")
      }else{
        this.$message(result['errMsg'])
      }
    },

    refundWayBill(){

    }
  },

}
</script>

<style>

.header-selector{
  position: absolute;
  top: 5px;
  left: 1%;
  z-index: 999;
}
.table-title{
  border-top: 1px solid #f0f0f0;
  border-left: 1px solid #f0f0f0;
  border-right: 1px solid #f0f0f0;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  display: flex;
  justify-content: center;
  align-content: center;
  padding: 7px 0 10px 0;
  color: #898989;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/instrument/EquipmentTableComponent.vue